import { Autocomplete, Box, Button, Checkbox, CircularProgress, Collapse, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material';
import React, { useEffect } from 'react'
import AddBoxIcon from '@mui/icons-material/AddBox';
import Service from '../Networking/NetworkingUtils';
import { getCookie } from '../Utils/CookieHelper';
import { useSnackbar } from 'notistack';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';


const token = getCookie("bb_metaverse_token");
var user = JSON.parse(getCookie('bb_metaverse_user'))

const ProjectOwner = (props) => {

    const [loading, setLoading] = React.useState(true);
    const [columns] = React.useState([
        { title: 'Name', field: 'user_details', editable: 'never', render: rowData => rowData.user_last_name + ", " + rowData.user_first_name },
        // { title: 'Stakeholder', field: 'stakeholder', type: 'boolean', render: rowData => rowData.stakeholder ? <CheckIcon/> : <HorizontalRuleIcon/> },
        { title: 'Role', field: 'role', lookup: { 0: 'Owner', 1: 'Contributor' } },
    ]);
    const [tableData, setTableData] = React.useState([]);
    const { enqueueSnackbar } = useSnackbar();
    const [editRowId] = React.useState(null);
    const [editRowData, setEditRowData] = React.useState({});
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [users, setUsers] = React.useState([]);
    const [selectedUser, setSelectedUser] = React.useState(null);
    const [disabled, setDisabled] = React.useState(false);



    const getData = () => {
        Service.get(`/api/project/managers/get_project_managers/?project=${props.project.id}`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                setTableData(res.data)
                setLoading(false)

            })
            .catch(error => {
                console.log(error)
                enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            });
    }

    useEffect(() => {
        getData()
        getUsers()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function getUsers() {
        Service.get('/api/users/get_user/', {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                // let existUserIDs = []
                // for (let index = 0; index < tableData.length; index++) {
                //     const element = tableData[index];
                //     existUserIDs.push(element.user)
                // }
                let users = []
                for (let index = 0; index < res.data.length; index++) {
                    const element = res.data[index];
                    // if (!existUserIDs.includes(element.id)) {
                        users.push(element)
                    // }
                }
                setUsers(users)
            })
            .catch(error => {
                console.log(error)
                enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            });
    }

    function addManager() {
        setDisabled(true);
        if(!selectedUser) {
            enqueueSnackbar('Please select a user!', {
                variant: 'warning'
            });
            setDisabled(false);
            return;
        }else{
            Service.post('/api/project/managers/create_project_managers/', {
            headers: {
                Authorization: "Token " + token,
            },
            data: {
                user: selectedUser.id,
                project: props.project.id,
                created_by: user.id,
                role: editRowData.role || 0
            }
        })
            .then(res => {
                enqueueSnackbar('Project owner added successfully!', {
                    variant: 'success'
                });
                getData()
                setDialogOpen(false)
                setDisabled(false);
            })
            .catch(error => {
                console.log(error)
                setDisabled(false);
                enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            });
        }
        }

    return (
        <div>
            {loading ? <Box display={'flex'} justifyContent={'center'} alignItems={'center'} width='100%'><CircularProgress /></Box> :
                <TableContainer component={Paper}>
                    <Box display='flex' justifyContent='space-between' alignItems='center' width='100%' paddingX={2}>
                        <Typography variant="h5">{props.project.name}</Typography>
                        <Box>
                            <Button onClick={() => setDialogOpen(true)}><Tooltip title="Add"><AddBoxIcon /></Tooltip></Button>
                        </Box>
                    </Box>
                    <React.Fragment>
                        <Table>
                            <TableHead>
                                <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                                    {/* <TableCell /> */}
                                    {columns && columns.map((column) => (
                                        <TableCell key={column.field}>{column.title}</TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tableData && tableData.map((row, idx) => (
                                    <React.Fragment key={row.id}>
                                        <TableRow
                                            onClick={() => {
                                                // Toggle open for this row only
                                                const updatedTableData = tableData.map((r, i) => {
                                                    if (i === idx) {
                                                        return { ...r, open: !r.open };
                                                    } else {
                                                        return { ...r, open: false };
                                                    }
                                                });
                                                setTableData(updatedTableData);
                                                // Set left/right based on access_data for this row
                                                const leftList = [];
                                                const rightList = [];
                                                if (row.access_data) {
                                                    Object.entries(row.access_data).forEach(([key, value]) => {
                                                        if (value === true) {
                                                            leftList.push(key);
                                                        } else {
                                                            rightList.push(key);
                                                        }
                                                    });
                                                }
                                                // setLeft(leftList);
                                                // setRight(rightList);
                                            }}
                                            sx={{ cursor: 'pointer' }}
                                        >
                                            {columns && columns.map((column) => (
                                                <TableCell key={column.field}  >
                                                    {editRowId === row.id ? (
                                                        // column.field === 'stakeholder' ? (
                                                        //     <Checkbox
                                                        //         color='primary'
                                                        //         checked={!!editRowData.stakeholder}
                                                        //         onChange={e => setEditRowData({ ...editRowData, stakeholder: e.target.checked })}
                                                        //     />
                                                        // ) : 
                                                        column.field === 'is_unlimited' ? (
                                                            <Checkbox
                                                                color='primary'
                                                                checked={!!editRowData.is_unlimited}
                                                                onChange={e => setEditRowData({ ...editRowData, is_unlimited: e.target.checked })}
                                                            />
                                                        ) : column.field === 'start_date' ? (
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                <DatePicker
                                                                    format='DD/MM/YYYY'
                                                                    label="Start Date"
                                                                    value={editRowData.start_date ? dayjs(editRowData.start_date) : null}
                                                                    onChange={newValue => setEditRowData({ ...editRowData, start_date: dayjs(newValue).format('YYYY-MM-DD') })}
                                                                />
                                                            </LocalizationProvider>
                                                        ) : column.field === 'end_date' ? (
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                <DatePicker
                                                                    format='DD/MM/YYYY'
                                                                    label="End Date"
                                                                    value={editRowData.end_date ? dayjs(editRowData.end_date) : null}
                                                                    onChange={newValue => setEditRowData({ ...editRowData, end_date: dayjs(newValue).format('YYYY-MM-DD') })}
                                                                />
                                                            </LocalizationProvider>
                                                        ) : column.render ? column.render(editRowData) : column.lookup ? column.lookup[editRowData[column.field]] : editRowData[column.field]
                                                    ) : (
                                                        column.render ? column.render(row) : column.lookup ? column.lookup[row[column.field]] : row[column.field]
                                                    )}
                                                </TableCell>
                                            ))}
                                           
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                                                <Collapse in={row.open} timeout="auto" unmountOnExit>
                                                    <Box margin={2}>

                                                    </Box>
                                                </Collapse>
                                            </TableCell>
                                        </TableRow>
                                    </React.Fragment>
                                ))}
                            </TableBody>
                        </Table>
                    </React.Fragment>
                </TableContainer>}
            <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} fullWidth maxWidth="xs">
                <DialogTitle>Add Project Owner</DialogTitle>
                <DialogContent>
                    {/* Form fields for adding project owner */}
                    <Box>
                        <Autocomplete
                            id="users"
                            value={selectedUser}
                            options={users}
                            getOptionLabel={(option) => option ? option['last_name'] + ", " + option['first_name'] : ''}
                            renderInput={(params) => <TextField variant='outlined' {...params} label="Users" />}
                            onChange={(event, values) => {
                                setSelectedUser(values);
                            }}
                            fullWidth
                        />
                    </Box>
                    <Box mt={1}>
                        <Select
                            fullWidth
                            labelId="role-label"
                            id="role"
                            value={editRowData.role}
                            label="Role"
                            onChange={(e) => setEditRowData({ ...editRowData, role: e.target.value })}
                        >
                            <MenuItem value={0}>Owner</MenuItem>
                            <MenuItem value={1}>Contributor</MenuItem>
                        </Select>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
                    <Button disabled={disabled} onClick={() => addManager()}>Add</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default ProjectOwner